import React from 'react';

const ProviderTabs = ({
  activeProvider,
  onProviderChange,
  microsoftConnected = false,
  googleConnected = false
}) => {
  const providers = [
    {
      id: 'microsoft',
      name: 'Microsoft 365',
      icon: (
        <svg className="w-5 h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H11V11H0V0Z" fill="#F25022"/>
          <path d="M12 0H23V11H12V0Z" fill="#7FBA00"/>
          <path d="M0 12H11V23H0V12Z" fill="#00A4EF"/>
          <path d="M12 12H23V23H12V12Z" fill="#FFB900"/>
        </svg>
      ),
      connected: microsoftConnected
    },
    {
      id: 'google',
      name: 'Google Workspace',
      icon: (
        <svg className="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
      ),
      connected: googleConnected
    }
  ];

  return (
    <div className="border-b border-gray-200 dark:border-gray-700">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {providers.map((provider) => {
          const isActive = activeProvider === provider.id;
          const isDisabled = !provider.connected;

          return (
            <button
              key={provider.id}
              onClick={() => !isDisabled && onProviderChange(provider.id)}
              disabled={isDisabled}
              className={`
                group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm
                ${isActive
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : isDisabled
                    ? 'border-transparent text-gray-400 dark:text-gray-500 cursor-not-allowed'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                }
              `}
            >
              <span className={`mr-2 ${isDisabled ? 'opacity-50' : ''}`}>
                {provider.icon}
              </span>
              <span>{provider.name}</span>
              {!provider.connected && (
                <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400">
                  Not Connected
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default ProviderTabs;
